module.exports = __webpack_public_path__ + "static/media/011ty@4x.1cebedda.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/011ty@4x.png
// module id = 416
// module chunks = 0 1